<template>
  <div class="w-100">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ getMetaTitle }}</title>
      <meta name="title" :content=" getMetaTitle">
      <meta name="description" :content="getMetaDescription">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" :content="appUrl + $route.path">
      <meta property="og:title" :content=" getMetaTitle">
      <meta property="og:description" :content="getMetaDescription">
      <meta property="og:image"
            :content="appUrl +'/VTStack_partage_'
            + $route.params.productCategory+'.jpg'">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" :content="appUrl + $route.path">
      <meta property="twitter:title" :content=" getMetaTitle">
      <meta property="twitter:description" :content=" getMetaDescription">
      <meta property="twitter:image"
            :content="appUrl + '/VTStack_partage_' + $route.params.productCategory+'.jpg'">
    </Head>
    <div v-if="!isMobile" class="wrapper fixed">
      <div class="vw-100 d-flex scalable">
        <div class="sf-block-mid-screen position-relative">
          <div class="sf-block-left sf-block-row">
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock/>
            </div>
            <div class="sf-block-col">
              <SFBlock :hidden="true"/>
              <SFBlock :background="require('@/assets/images/background/Bg_Btn_Design_bw.svg')"/>
            </div>
            <div class="sf-block-col">
              <SFBlock :hidden="true"/>
              <SFBlock :background="require('@/assets/images/background/Bg_Btn_Graph_bw.svg')"/>
            </div>
          </div>
        </div>
        <div class="sf-block-mid-screen position-relative">
          <div class="sf-block-right sf-block-row">
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock :background="require('@/assets/images/background/Bg_Btn_Support_bw.svg')"/>
              <SFBlock :background="require('@/assets/images/background/Bg_Btn_Sound_bw.svg')"/>
            </div>
            <div class="sf-block-col">
              <SFBlock/>
              <SFBlock/>
              <SFBlock/>
            </div>
            <div class="sf-block-col" style="visibility: hidden">
              <SFBlock/>
              <SFBlock/>
              <SFBlock/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper justify-content-between">
      <TheHeader :displayMenu= true />
      <main class="products-page">
        <div v-if="displayContent()" class="content">

          <div class="animate__animated animate__slideInLeft"
               style="z-index: 1;">
            <TheBreadcrumb :currentCategory="$route.params.productCategory" />
            <div class="search-form">
              <img src="@/assets/images/icons/Icon_Search.svg"
                   alt="search-icon" class="search-icon">
              <input type="text"
                     class="field"
                     :name=" t('label.search')"
                     :placeholder=" t('label.search')"
                     v-bind:value = searchTerm
                     @keyup="textSearch($event)"/>
              <img v-if="searchTerm"
                   @click.stop="clearSearch"
                  src="@/assets/images/icons/Icon_cancel.svg"
                   alt="search-delete-icon"
                   class="search-delete-icon animate__animated animate__tada">
            </div>
            <div class="sortPanel">
              <div @click="displaySorters"
                   :class="{'cursor-hand':isMobile}"
                   class="d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <img class="icon mx-4 my-3" src="@/assets/images/icons/Tri_icon.svg" alt="">
                  <div class="my-3 title">{{ t('label.sort')}}</div>
                </div>
              </div>
              <div ref="sorters" class="sorters">
                <div class="separator">
                  <div class="values active py-3">
                    <div class="py-1 value" @click.prevent = "setSort('date')"
                         :class="{'active': currentSort === 'date'}">
                      {{ t('label.sort.date')}}</div>
                    <div class="py-1 value" @click.prevent = "setSort('alphanumeric')"
                         :class="{'active': currentSort === 'alphanumeric'}">
                      {{ t('label.sort.alphanumeric')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="hasNewAsset || products.filters.length > 0"
              class="filterPanel">
              <div @click="displayFilters"
                   :class="{'cursor-hand':isMobile}"
                   class="d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <img class="icon mx-4 my-3" src="@/assets/images/icons/Icon_Filter.svg" alt="">
                  <div class="my-3 title">{{ t('label.filters')}}</div>
                </div>
                <img v-if="filtersApplied.length > 0"
                     @click = "emptyFilters"
                     class="delete mx-4 my-3 animate__animated animate__tada"
                     src="@/assets/images/icons/Icon_Delete.svg" alt="">
              </div>
              <div ref="filters" class="filters">
                <div v-if="hasNewAsset" class="separator">
                  <div class="values active py-3">
                    <div class="py-1 value"
                         :class="{'active':displayNewItemOnly}"
                         @click.prevent = "displayNewItemOnly = !displayNewItemOnly;
                         this.buildURLArgs();">
                      {{ t('label.filters.recently.added') }}
                    </div>
                  </div>
                </div>
                <div v-for="filterCat in products.filters" :key="filterCat.ID"
                     class="separator">
                  <div class="py-3 cat">{{ filterCat.LocName }}</div>
                  <div class="values active">
                    <div class="py-1 value"
                         :class="{'active':catHasNoActiveFilter(filterCat)}"
                         @click.prevent = "clearCatFilter(filterCat)">
                      {{ t('label.search.all')}}</div>
                    <div v-for="filter in filterCat.Values" :key="filter.ID"
                         class="">
                      <div class="py-1 value"
                           :class="{'active':isActive(filter)}"
                           @click.prevent = "setActive(filter,filterCat)">
                        {{ filter.LocName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="filteredAssets.length > 0"
               class="animate__animated animate__slideInRight
               content-list mt-5" >
            <InfoAssetBlock v-if="false"
                            :title="t('video.info.' + $route.params.productCategory+ '.title')"
                            :icon="require('@/assets/images/icons/Play.svg')"
                            :preview="t('video.info.' + $route.params.productCategory+ '.link')" />
            <AssetBlock
              v-for="product in filteredAssets" :key="product.Id"
              :product=product
              :id=product.Id
              :fileName=product.Filename
              :type=currentAssetType
              :meta=product.Metas
              :title=product.Name
              :subtitle=product.Subtitle
              :mainfilter= mainFilterValue(product.Filters)
              :date= product.AddedAt
              :downloaded= product.Owned
              :preview='product.Previews.length > 0 ? product.Previews[0] : null'
              :activePlayer=activePreviewPlayer
              @preview-sound="previewSound"
            />
            <div class="info-block
            asset-block d-flex flex-column
            align-items-center justify-content-around
            py-5 px-5"
                 @click.prevent="displayContactFrom()">
              <p class="t1">{{ t('contact.form.action.1') }}</p>
              <p class="t2">{{ t('contact.form.action.2') }}</p>
              <div class="btns py-2">
                  <span class="button justify-content-start"  @click.prevent="displayContactFrom()">
                    {{ $t('contact.form.action.3') }}</span>
              </div>
            </div>
          </div>
          <div v-else
               class="animate__animated animate__slideInRight
               no-content mt-5">
            <div
              class="d-flex w-100 no-content-avatar">
              <img class="h-100" v-lazy="require('@/assets/images/avatar/'+randomAvatar)"/>
              <blockquote class="ml-3">
                <p class="title">{{ t('label.oups') }}</p>
                <p class="subtitle">{{ t('label.no.result') }}</p>
                <p class="t1">{{ t('contact.form.action.1') }}</p>
                <p class="t2">{{ t('contact.form.action.2') }}</p>
                <div class="btns py-2">
                  <span class="button justify-content-start"  @click.prevent="displayContactFrom()">
                    {{ $t('contact.form.action.3') }}</span>
                </div>
              </blockquote>

            </div>
          </div>
        </div>
        <div v-else class="content ">
          <router-view></router-view>
        </div>
      </main>
      <TheFooter/>
    </div>
    <NeedAccount ref="confirmDialogue"></NeedAccount>
    <ContactForm ref="contactForm"></ContactForm>
    <PreviewCanvas
      :class="{'offcanvas-on': showPreview}"
      :type="currentPreviewType"
      :media-title="currentMediaTitle"
      :media-description="currentMediaDescription"
      :mediaUrl="currentMediaUrl"
      @close="closePreview"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TheHeader from '@/components/ui/TheHeader.vue';
import TheBreadcrumb from '@/components/ui/TheBreadcrumb.vue';
import SFBlock from '@/components/ui/SFBlock.vue';
import AssetBlock from '@/components/ui/AssetBlock.vue';
import InfoAssetBlock from '@/components/ui/InfoAssetBlock.vue';
import TheFooter from '@/components/ui/TheFooter.vue';
import HelperMixin from '@/mixins/helperMixin';
import PreviewCanvas from '@/components/canvas/PreviewCanvas.vue';
import { Head } from '@vueuse/head';
import {
  FETCH_PRODUCTS,
} from '@/store/actions.type';
import NeedAccount from '@/components/canvas/NeedAccount.vue';
import ContactForm from '@/components/canvas/ContactForm.vue';
import { APP_URL } from '@/common/config';
import { useI18n } from 'vue-i18n';
import store from '../store';

export default {
  name: 'ProductsView',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  mixins: [HelperMixin],
  components: {
    TheHeader,
    TheBreadcrumb,
    SFBlock,
    InfoAssetBlock,
    AssetBlock,
    NeedAccount,
    ContactForm,
    TheFooter,
    PreviewCanvas,
    Head,
  },
  computed: {
    ...mapGetters(['products']),
    filteredAssets() {
      let filteredAssetsList = this.products.products;
      if (this.displayNewItemOnly) {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        // eslint-disable-next-line max-len
        filteredAssetsList = filteredAssetsList.filter((product) => new Date(product.AddedAt) > date);
        if (filteredAssetsList.length === 0) {
          return filteredAssetsList;
        }
      }
      if (this.filtersApplied.length !== 0) {
        filteredAssetsList = filteredAssetsList.filter((product) => this.filtersApplied.every(
          (filterApplied) => product.Filters.includes(filterApplied.ID),
        ));
      }
      filteredAssetsList = filteredAssetsList.filter(
        (product) => (product.Name.toLowerCase()
          .includes(this.searchTerm.toLowerCase())
          || (product.Subtitle ? product.Subtitle.toLowerCase()
            .includes(this.searchTerm.toLowerCase()) : false)),
      );
      return filteredAssetsList.sort((a, b) => {
        if (this.currentSort === 'date') {
          const order = new Date(b.AddedAt) - new Date(a.AddedAt);
          if (order !== 0) {
            return order;
          }
        }
        return a.Name.localeCompare(b.Name, 'en', { numeric: true });
      });
    },
    currentAssetType() {
      return this.$route.params.productCategory;
    },
    getMetaTitle() {
      switch (this.$route.params.productCategory) {
        default:
        case 'design_assets': return this.$t('meta.design.title');
        case 'graph_assets': return this.$t('meta.graph.title');
        case 'sound_assets': return this.$t('meta.sound.title');
        case 'support_assets': return this.$t('meta.support.title');
      }
    },
    getMetaDescription() {
      switch (this.$route.params.productCategory) {
        default:
        case 'design_assets': return this.$t('meta.design.description');
        case 'graph_assets': return this.$t('meta.graph.description');
        case 'sound_assets': return this.$t('meta.sound.description');
        case 'support_assets': return this.$t('meta.support.description');
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(FETCH_PRODUCTS, { type: to.params.productCategory })
      .then(() => {
        next();
      });
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.respondToRouteChanges) {
      this.respondToRouteChanges = true;
      next();
    }
    const { locale } = this.$root.$i18n;
    store.dispatch(FETCH_PRODUCTS, { type: to.params.productCategory, locale })
      .then(() => {
        this.applyURLArgs(`${window.location.origin}${to.fullPath}`);
        next();
      });
  },
  mounted() {
    const blocks = document.querySelectorAll('.sf-block');
    blocks.forEach((block, index) => {
      if (block.classList.contains('hidden')) {
        return;
      }
      setTimeout(() => { block.classList.add('active'); }, index * 100);
    });
    this.audioPlayer = new Audio();
    this.applyURLArgs(window.location);
    let avatar = '';
    const random = Math.floor(Math.random() * 9);
    switch (random) {
      default:
      case 1: avatar = 'Arthur_P5.png'; break;
      case 2: avatar = 'Audrey_P5.png'; break;
      case 3: avatar = 'Fanny_P5.png'; break;
      case 4: avatar = 'Joseph_P5.png'; break;
      case 5: avatar = 'Leila_P5.png'; break;
      case 6: avatar = 'Lise_P5.png'; break;
      case 7: avatar = 'Salim_P5.png'; break;
      case 8: avatar = 'Thibaut_P5.png'; break;
    }
    this.randomAvatar = avatar;
    const ga = document.createElement('script');
    ga.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-MFQVNJCY39');
    ga.setAttribute('async', '');
    document.head.appendChild(ga);
    /* eslint-disable */
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'G-MFQVNJCY39');
    /* eslint-enable */
  },
  data() {
    return {
      audioPlayer: null,
      activePreviewPlayer: null,
      randomAvatar: 'Arthur_P5.png',
      showPreview: false,
      currentPreviewType: 'video',
      loadedAssets: 20,
      currentMediaUrl: null,
      currentMediaTitle: null,
      currentMediaDescription: null,
      filtersApplied: [],
      displayNewItemOnly: false,
      currentSort: 'alphanumeric',
      searchTerm: '',
      respondToRouteChanges: true,
      timer: undefined,
      appUrl: APP_URL,
    };
  },
  methods: {
    hasNewAsset() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      return this.products.products.any((product) => new Date(product.AddedAt) > date);
    },
    displayContent() {
      document.dispatchEvent(new Event('render-event'));
      return this.$route.name === 'ProductsView';
    },
    displayFilters() {
      const { filters } = this.$refs;
      if (filters.classList.contains('active')) {
        filters.classList.remove('active');
      } else {
        filters.classList.add('active');
      }
    },
    displaySorters() {
      const { sorters } = this.$refs;
      if (sorters.classList.contains('active')) {
        sorters.classList.remove('active');
      } else {
        sorters.classList.add('active');
      }
    },
    displayPreview(type, url, title, description = null) {
      this.activePreviewPlayer = 'preview';
      this.currentPreviewType = type;
      this.currentMediaUrl = url;
      this.currentMediaTitle = title;
      this.currentMediaDescription = description;
      this.showPreview = true;
    },
    closePreview() {
      this.activePreviewPlayer = null;
      this.showPreview = false;
    },
    previewSound(args) {
      this.activePreviewPlayer = args.next;
    },
    setActive(element, category) {
      const index = this.filtersApplied.indexOf(element);
      if (index > -1) {
        this.filtersApplied.splice(index, 1);
      } else {
        category.Values.forEach((val) => {
          const indexCat = this.filtersApplied.indexOf(val);
          if (indexCat > -1) {
            this.filtersApplied.splice(indexCat, 1);
          }
        });
        this.filtersApplied.push(element);
      }
      this.buildURLArgs();
    },
    clearCatFilter(category) {
      category.Values.forEach((val) => {
        const indexCat = this.filtersApplied.indexOf(val);
        if (indexCat > -1) {
          this.filtersApplied.splice(indexCat, 1);
        }
      });
      this.buildURLArgs();
    },
    catHasNoActiveFilter(category) {
      return !category.Values.some((val) => this.filtersApplied.indexOf(val) > -1);
    },
    isActive(menuItem) {
      return this.filtersApplied.indexOf(menuItem) > -1;
    },
    toogleCategory(event) {
      const catItem = event.target;
      const content = catItem.nextSibling;
      catItem.classList.toggle('active');
      content.classList.toggle('active');
    },
    emptyFilters() {
      this.filtersApplied = [];
      this.buildURLArgs();
    },
    textSearch(value) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchTerm = value.target.value;
        this.buildURLArgs();
      }, 300);
    },
    clearSearch() {
      this.searchTerm = '';
      this.buildURLArgs();
    },
    setSort(sort) {
      this.currentSort = sort;
      this.buildURLArgs();
    },
    playSound(sound) {
      if (this.audioPlayer.duration > 0 && !this.audioPlayer.paused) {
        this.audioPlayer.pause();
      }
      this.audioPlayer.src = sound;
      this.audioPlayer.load();
      this.audioPlayer.play();
    },
    mainFilterValue(productFilters) {
      let mainFilter = null;
      if (productFilters.length > 0 && this.products.filters.length > 0) {
        const mainFilterValues = this.products.filters[0].Values;
        const filters = mainFilterValues.filter((filter) => productFilters.includes(filter.ID));
        if (filters.length > 0) {
          mainFilter = filters[0].LocName;
        }
      }
      return mainFilter;
    },
    buildURLArgs() {
      const params = new URLSearchParams();
      if (this.searchTerm !== '') {
        params.set('search', this.searchTerm);
      }
      params.set('new', this.displayNewItemOnly);
      params.set('sort', this.currentSort);
      if (this.filtersApplied.length > 0) {
        this.filtersApplied.forEach((filter) => { params.append('filter', filter.ID); });
      }
      this.respondToRouteChanges = false;
      this.$router.push(`${this.$route.path}?${params.toString()}`).finally(() => {
        this.respondToRouteChanges = true;
      });
    },
    applyURLArgs(urlString) {
      this.searchTerm = '';
      this.displayNewItemOnly = false;
      this.filtersApplied = [];
      this.currentSort = 'alphanumeric';
      const url = new URL(urlString);
      const searchParams = new URLSearchParams(url.search);
      searchParams.forEach((value, key) => {
        if (key === 'new') {
          this.displayNewItemOnly = value === 'true';
        }
        if (key === 'search') {
          this.searchTerm = value;
        }
        if (key === 'sort') {
          this.currentSort = value;
        }
        if (key === 'filter') {
          const intVal = parseInt(value, 10);
          this.products.filters.forEach((cat) => {
            cat.Values.forEach((filter) => {
              if (filter.ID === intVal) {
                this.filtersApplied.push(filter);
              }
            });
          });
        }
      });
    },
    displayContactFrom() {
      this.$refs.contactForm.show();
    },
  },
};
</script>

<style scoped>

</style>
